module.exports = __webpack_public_path__ + "img/signup-carousel-fifth@3x.02624c06.png";